// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { DropdownItemTypes } from './dropdown-item.model';

@Component({
  selector: 'e-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./dropdown-item.component.scss'],
})
export class DropdownItemComponent {
  @Input() type : DropdownItemTypes | string = DropdownItemTypes.Link;
}
